export enum CheckboxTheme {
  LIGHT = "light",
  DARK = "dark",
}